import React, {useEffect} from "react";
import {Tree} from "antd";
import {useModel, useModelDispatchers} from "../../../models";

export default function () {
    const [{customerTypeDict}, {getCustomerTypeDict}] = useModel("cmDict");
    const {setSelectedTypeNode} = useModelDispatchers("customer");
    useEffect(() => {
        getCustomerTypeDict();
    }, [])
    const onSelect = (selectedKeys, info) => {
        // console.log(info)
        if (info.selectedNodes && info.selectedNodes.length > 0&&info.selected==true) {
            //获取父节点
            const selectedNode = info.selectedNodes[0];
            setSelectedTypeNode(selectedNode);
            
        }else{
            setSelectedTypeNode(null);
        }
    };
    return (
        <Tree
            defaultExpandedKeys={['0-0-0']}
            onSelect={onSelect}
            treeData={customerTypeDict}
            style={{height: "100%",width:"250px"}}
        />
    );

};